import { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { evPersonalizationMarkerHover, evPersonalizationMarkerImpression, evPersonalizationMarkerLoginClick } from 'events/landing';
import {
  RECOGNIZED_USER_INSUFFICIENT_DATA,
  RECOGNIZED_USER_SUFFICIENT_DATA,
  UNRECOGNIZED_USER
} from 'constants/personalizationMarkerTypes';

import PersonalizationMarkerNonRecIconLarge from 'images/not-recognized-marker.svg';
import PersonalizationMarkerRecIconLarge from 'images/recognized-marker.svg';
import css from 'styles/components/landing/personalizationMarker.scss';
import Tooltip from 'components/common/Tooltip';
import { track } from 'apis/amethyst';

export class PersonalizationMarker extends Component {
  componentDidMount() {
    const { componentName, sourcePage, type } = this.props;
    track(evPersonalizationMarkerImpression, {
      componentName,
      sourcePage,
      type
    });
  }

  onMouseEnter = () => {
    const { componentName, sourcePage, type } = this.props;
    track(evPersonalizationMarkerHover, {
      componentName,
      sourcePage,
      type
    });
  };

  signInClickHandler = e => {
    const { componentName, sourcePage, type, onSignInClick } = this.props;
    track(evPersonalizationMarkerLoginClick, {
      componentName,
      sourcePage,
      type
    });
    onSignInClick && onSignInClick(e);
  };

  getTypeInfo = (type, location, authUrl) => {
    const { pathname, search } = location;
    switch (type) {
      case UNRECOGNIZED_USER:
        return {
          className: css.pNonRecMrkSmall,
          label: 'Non-recognized customer',
          contents: <>
            <div data-test-img-type={type}>
              <img src={PersonalizationMarkerNonRecIconLarge} alt="" />
            </div>
            <div>
              <p>These items can be tailored for you.</p>
              <p><Link to={`${authUrl}${pathname}${search}`} onClick={this.signInClickHandler}>Sign In</Link> to see items which match your preferences.</p>
            </div>
          </>
        };
      case RECOGNIZED_USER_INSUFFICIENT_DATA:
        return {
          className: css.pRecMrkSmall,
          label: 'Recognized customer',
          contents: <>
          <div data-test-img-type={type}>
            <img src={PersonalizationMarkerRecIconLarge} alt="" />
          </div>
          <div>
            <p>We do not have enough information about your preferences to personalize these items. Please browse around more to help us learn what you like.</p>
          </div>
          </>
        };
      case RECOGNIZED_USER_SUFFICIENT_DATA:
        return {
          className: css.pRecMrkSmall,
          label: 'Recognized customer',
          contents: <>
          <div data-test-img-type={type}>
            <img src={PersonalizationMarkerRecIconLarge} alt="" />
          </div>
          <div>
            <p>These items have been personalized based on your preferences. If these don't match your tastes, please browse around more to help us learn what you like.</p>
          </div>
          </>
        };
    }

    return {
      className: null,
      label: 'Unknown personalization icon',
      contents: ''
    };
  };

  render() {
    const { iconAlignment, contentsAlignment, type, contents, location } = this.props;
    const { marketplace: { authUrl = '' } = {} } = this.context;
    const pointyDirection = contentsAlignment ? contentsAlignment : iconAlignment === 'right' ? 'left' : 'right';
    const alignToLeftSideOfIcon = (iconAlignment === 'left' && contentsAlignment === 'left');
    const { className: markerClassName, label: markerLabel, contents: defaultContents } = this.getTypeInfo(type, location, authUrl);
    return <Tooltip
      tooltipId="personalizationMarker"
      wrapperClassName={cn(css.tooltipWrapper, { [css.pMrkSmallRightAlgn]: (iconAlignment === 'right') })}
      contentClassName={cn(css.tooltipContent, css.shrinkOnTabletPortrait)}
      tooltipClassName={cn(css.tooltip, { [css.leftSideOfIcon]: alignToLeftSideOfIcon })}
      direction={pointyDirection}
      onMouseEnter={this.onMouseEnter}
      content={contents || defaultContents}>
      <span className={cn(css.pMrkSmall, markerClassName)} aria-label={markerLabel} />
    </Tooltip>;
  }
}

PersonalizationMarker.propTypes = {
  iconAlignment: PropTypes.string,
  contents: PropTypes.string,
  contentsAlignment: PropTypes.string,
  location: PropTypes.object,
  sourcePage: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired // As defined in constants/personalizationMarkerTypes
};

PersonalizationMarker.defaultProps = {
  iconAlignment: 'left',
  contents: '',
  location: { pathname: '', search: '' },
  contentsAlignment: ''
};

PersonalizationMarker.contextTypes = {
  marketplace: PropTypes.object
};

export default PersonalizationMarker;
